var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Carpentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vW78JuHOUsgiJ5zKrjy7ea",
    x1: 40.63,
    x2: 40.628,
    y1: 8.91,
    y2: 26.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad570d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vW78JuHOUsgiJ5zKrjy7ea)",
    d: "M33.372,27h14.511c-0.554-4.777-3.003-7.68-4.523-9.959l-1.965-2.948 c-0.789-1.184-0.542-2.775,0.569-3.664l1.145-0.916c1.054-0.843,1.248-2.371,0.438-3.45c-0.846-1.129-2.458-1.333-3.56-0.452 L35.76,8.992c-2.095,1.676-2.481,4.713-0.871,6.859l1.688,2.25c0.924,1.232,1.423,2.73,1.423,4.27C38,24.928,35.928,27,33.372,27z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vW78JuHOUsgiJ5zKrjy7eb",
    x1: 17.086,
    x2: 17.527,
    y1: 14.487,
    y2: 31.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad570d"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vW78JuHOUsgiJ5zKrjy7eb)",
    d: "M11.992,30.608l-3.426-2.065l6.54-10.851c0.379-0.629,1.197-0.832,1.826-0.453l2.286,1.378 L11.992,30.608z M15,27h11V16h-5L15,27z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vW78JuHOUsgiJ5zKrjy7ec",
    x1: 20.213,
    x2: 20.204,
    y1: 18.537,
    y2: 31.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vW78JuHOUsgiJ5zKrjy7ec)",
    d: "M26.149,8.683L26.149,8.683c-0.71-0.428-1.631-0.199-2.059,0.51L13.766,26.323 c-0.428,0.71-0.199,1.631,0.51,2.059l0,0c0.71,0.428,1.631,0.199,2.059-0.51L26.66,10.742C27.087,10.032,26.859,9.111,26.149,8.683 z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vW78JuHOUsgiJ5zKrjy7ed",
    x1: 23.004,
    x2: 24.934,
    y1: 24.949,
    y2: 40.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vW78JuHOUsgiJ5zKrjy7ed)",
    d: "M1,40h46c0.552,0,1-0.448,1-1V27c0-1.105-0.895-2-2-2H6.828c-0.53,0-1.039,0.211-1.414,0.586 l-4.828,4.828C0.211,30.789,0,31.298,0,31.828V39C0,39.552,0.448,40,1,40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Carpentry);
export default __webpack_public_path__ + "static/media/icons8-carpentry.92ff38739bd947701dccc939be014d9b.svg";
export { ForwardRef as ReactComponent };